import { createContext } from 'react';

export const DynamicQuestionsContext = createContext();

export const initialState = {
  currentQuestionKeys: {},
  allQuestionKeys: [],
  currentItemId: 0,
};

export const TYPES = {
  ADD_CURRENT_QUESTION_KEYS: 'ADD_CURRENT_QUESTION_KEYS',
  ADD_ALL_QUESTION_KEYS: 'ADD_ALL_QUESTION_KEYS',
  ADD_CURRENT_ITEM_ID: 'ADD_CURRENT_ITEM_ID',
};

export const provider = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ADD_CURRENT_QUESTION_KEYS:
      return {
        ...state,
        currentQuestionKeys: action.payload,
      };
    case TYPES.ADD_ALL_QUESTION_KEYS:
      return {
        ...state,
        allQuestionKeys: action.payload,
      };
    case TYPES.ADD_CURRENT_ITEM_ID:
      return {
        ...state,
        currentItemId: action.payload,
      };

    default:
      return state;
  }
};
